<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
            <el-form-item label="包类型" prop="platform">
                <el-radio-group v-model="form.platform">
                    <el-radio :label="1">安卓</el-radio>
                    <el-radio :label="2">IOS</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="版本名称" prop="versionName">
                <el-input v-model="form.versionName" placeholder="请输入版本名称" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="版本号" prop="versionCode">
                <el-input v-model="form.versionCode" placeholder="请输入版本号" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="URL地址" prop="downloadUrl">
                <el-input v-model="form.downloadUrl" placeholder="请输入URL地址" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="是否强制更新" prop="forceUpdate">
                <el-switch v-model="form.forceUpdate" />
            </el-form-item>
            <el-form-item label="版本更新内容" prop="updateContent">
                <Editor v-model="form.updateContent" />
            </el-form-item>
            <el-form-item>
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/content/app";
import Editor from "@/components/Editor.vue";
export default {
    components: { Editor },
    data() {
        return {
            form: {
                platform: 1,
                versionName: "",
                versionCode: "",
                downloadUrl: "",
                forceUpdate: false,
                updateContent: ""
            },
            rules: {
                platform: [{ required: true, message: "请选择包类型", trigger: "change" }],
                versionName: [{ required: true, message: "请输入版本名称", trigger: "blur" }],
                versionCode: [{ required: true, message: "请输入版本号", trigger: "blur" }],
                downloadUrl: [{ required: true, message: "请输入URL地址", trigger: "blur" }],
                updateContent: [{ required: true, message: "请输入版本更新内容", trigger: "blur" }]
            }
        }
    },
    mounted() {
        const id = this.$route.query.id;
        if (id) {
            this.getDetail(id);
        }
    },
    methods: {
        getDetail(id) {
            detail({ id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.form = result;
                    this.form.forceUpdate = this.form.forceUpdate == 1 ? true : false;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleCancel() {
            this.$router.back();
        },
        handleSubmit() {
            const params = {
                ...this.form,
                forceUpdate: this.form.forceUpdate ? 1 : 0
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        edit(params).then(({ code, message }) => {
                            if (code == 200) {
                                this.$message.success('保存成功');
                                this.$router.back();
                            } else {
                                this.$message.error(message);
                            }
                        });
                    } else {
                        add(params).then(({ code, message }) => {
                            if (code == 200) {
                                this.$message.success('保存成功');
                                this.$router.back();
                            } else {
                                this.$message.error(message);
                            }
                        });
                    }
                }
            });
        }
    }
}
</script>

<style></style>